module.exports = __webpack_public_path__ + "static/media/EPLD@1x(Grey).ca53fe42.png";